
<button
  class="reactions-button like"
  [ngClass]="{
    'active': reaction() === chatMessageReaction.like,
    'hidden': reaction() === chatMessageReaction.dislike
  }"
  type="button"
  puButton
  uiType="quaternary"
  size="l"
  [onlyIcon]="true"
  (click)="toggleReaction(chatMessageReaction.like)"
>
  <pu-icon iconName="like" size="20" />
</button>

<button
  class="reactions-button dislike"
  [ngClass]="{
    'active': reaction() === chatMessageReaction.dislike,
    'hidden': reaction() === chatMessageReaction.like
  }"
  type="button"
  puButton
  uiType="quaternary"
  size="l"
  [onlyIcon]="true"
  (click)="toggleReaction(chatMessageReaction.dislike)"
>
  <pu-icon iconName="dislike" size="20" />
</button>

@if (reaction()) {
  <div class="reaction-text">
    @if (feedbackProvided()) {
      {{ 'chatBot.reaction.provided.text' | translateIn }}
    } @else {
      {{ 'chatBot.reaction.' + reaction() + '.text' | translateIn }}
    }
    @if (reaction() === chatMessageReaction.dislike && !feedbackProvided()) {
      <button
        class="reaction-text__button"
        type="button"
        puButton
        uiType="quaternary"
        (click)="openFeedbackForm()"
      >
        {{ 'chatBot.buttons.leaveReview' | translateIn }}
      </button>
    }
  </div>
}
